"use client";

import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";

const SLOT = "col-start-1 row-start-1 transition-opacity duration-300 motion-reduce:transition-none";

export default function NavCta({
  isLoggedIn,
  className = "",
}: {
  isLoggedIn: boolean;
  className?: string;
}) {
  const [scrolled, setScrolled] = useState(false);
  const PanelCta = isLoggedIn ? "a" : Link;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={`${className} grid items-center justify-items-end md:justify-items-start`}>
      {!isLoggedIn && (
        <Link
          href="/sign-in"
          aria-hidden={scrolled}
          tabIndex={scrolled ? -1 : undefined}
          className={`${SLOT} inline-flex items-center min-h-[44px] px-2 text-sm font-medium text-muted-foreground hover:text-primary-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-lg ${
            scrolled ? "opacity-0 pointer-events-none" : "opacity-100"
          }`}
        >
          Iniciar sesión
        </Link>
      )}

      <PanelCta
        href={isLoggedIn ? "/agency" : "/sign-up"}
        aria-hidden={!isLoggedIn && !scrolled}
        tabIndex={isLoggedIn || scrolled ? undefined : -1}
        className={`${SLOT} inline-flex items-center justify-center gap-1.5 shrink-0 min-h-[40px] px-3 text-[13px] md:min-h-0 md:px-6 md:py-2 md:text-sm bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 whitespace-nowrap ${
          isLoggedIn || scrolled ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        {isLoggedIn ? "Ir al panel" : "Crear mi tienda"}
        <ArrowRight className="w-4 h-4 shrink-0" />
      </PanelCta>
    </div>
  );
}
